/*@flow*/
import useCompanyId from './useCompanyId';
import useContextState from './useContextState';
import isEmbedded from 'lib/isEmbedded';
import { state } from 'ops';
import getId from 'lib/getId';
import useQueryParams from './useQueryParams';
import addFooWhenTypesEmpty from './addFooWhenTypesEmpty';
import * as I from 'immutable';

function useDashboardId() {
  return getDashboardId();
}

function getDashboardId() {
  return state('$query.load.dashboardId') || getId('dashboards');
}

export default function useFilters(): any {
  const cid = useCompanyId();
  // HACK: We don't pass a companyId if the map is embedded in order to
  // ensure all public projects on the dashboard are returned by the API.
  const companyId = isEmbedded() ? undefined : cid;
  const dashboardId = useDashboardId();
  const { focusedLatlon } = useContextState();
  let filter = useQueryParams().get('filter') || I.Map();

  filter = filter.update((v) =>
    v
      .set('dashboardId', dashboardId)
      .set('companyId', companyId)
      .set('nearby', focusedLatlon)
  );

  filter = addFooWhenTypesEmpty(filter);

  return filter;
}
